import { ERROR_CODES } from 'constants/general';

import type { IErrorMessages } from 'store/slices/dataSets/interfaces/IErrorItem';
import type ISheetErrorsItem from 'store/slices/dataSets/interfaces/ISheetErrorsItem';

const checkHasDuplicateError = (
  sheetErrors: Record<string, ISheetErrorsItem>,
): boolean => Object.keys(sheetErrors)?.some((sheetKey) => {
  const sheet = sheetErrors[sheetKey];
  return Object.keys(sheet)?.some((recordKey) => {
    const record = sheet[recordKey] as unknown as Record<string, IErrorMessages[]>;
    return Object.keys(record).some((fieldKey) => {
      const fieldValue = record[fieldKey];
      if (Array.isArray(fieldValue)) {
        return fieldValue.some((error: IErrorMessages) => error.errorCode === ERROR_CODES.DUPLICATE_ERROR);
      }
      return false;
    });
  });
});

export default checkHasDuplicateError;
